import styled from 'styled-components';

export const StyledAlertHistoryBox = styled.div`
  width: 140px;
  height: 186px;
  border-radius: 8px;
  border: 1px solid rgba(146, 255, 192, 0.3);
  background:
    linear-gradient(0deg, #040404 0%, #040404 100%),
    linear-gradient(
      180deg,
      rgba(19, 19, 19, 0.2) 0%,
      rgba(19, 19, 19, 0.8) 63.5%,
      rgba(19, 19, 19, 0.8) 100%
    );
  box-shadow: 0px 10px 15.3px 0px rgba(13, 175, 160, 0.4) inset;
  padding: 8px 0px;

  > h2 {
    color: var(--color-white);
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    position: relative;
    padding-bottom: 17px;

    &::after {
      content: '';
      position: absolute;
      bottom: 10px;
      left: 50%;
      width: 140px;
      height: 1px;
      background: rgba(146, 195, 255, 0.3);
      transform: translateX(-50%);
    }
  }

  .alert-history-list {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
  }

  .alert-history-item {
    width: 116px;
    height: 36px;
    border-radius: 8px;
    border: 1px solid #2d2d2d;
    background: rgba(255, 255, 255, 0.25);
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--color-white);
    font-size: 15px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
`;
